import {
    createFetchReducer,
    INITIAL_FETCH_STATE
} from '../../../../../middleware';
import { DucsState } from './ducs-modal.types';

export const FETCH_DUCS_CONTENT = 'ducs';

export const INITIAL_DUCS_STATE: DucsState = INITIAL_FETCH_STATE;

export const getDucsContentReducer = () => {
    return createFetchReducer(
        FETCH_DUCS_CONTENT,
        INITIAL_DUCS_STATE
    );
};
